export const LATEST_SESSION_FEEDBACK_SECTION_IDS = {
  whatsWorking: 'whatsWorking',
  watchOut: 'watchOut',
  improvementIdea: 'improvementIdea',
  emotion: 'emotion'
} as const

export type LatestSessionFeedbackSectionId =
  (typeof LATEST_SESSION_FEEDBACK_SECTION_IDS)[keyof typeof LATEST_SESSION_FEEDBACK_SECTION_IDS]

/** The boxes a player uncovers before the feedback of a game counts as read. */
export const LATEST_SESSION_FEEDBACK_READ_SECTION_IDS: readonly LatestSessionFeedbackSectionId[] = [
  LATEST_SESSION_FEEDBACK_SECTION_IDS.whatsWorking,
  LATEST_SESSION_FEEDBACK_SECTION_IDS.watchOut
]
